var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "center_wrap" },
      [
        _c("div", { staticClass: "wrap_l" }, [
          _c(
            "div",
            { staticClass: "Item_list" },
            [
              _c("div", { staticClass: "weituo" }, [
                _c("img", {
                  attrs: { src: require("../../assets/weituo.png"), alt: "" }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "tittype" }, [
                  _vm._v(_vm._s(_vm.$t("i18n_Order_info")))
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "entrustForm",
                  attrs: {
                    "label-position": "right",
                    "label-width": "106px",
                    size: "small",
                    rules: _vm.entrustInfoRules,
                    model: _vm.entrustInfo
                  }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("i18n_contact_person") } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.Authorization.customerContact,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.Authorization,
                                      "customerContact",
                                      $$v
                                    )
                                  },
                                  expression: "Authorization.customerContact"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("i18n_contact_number") } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.Authorization.customerTel,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.Authorization,
                                      "customerTel",
                                      $$v
                                    )
                                  },
                                  expression: "Authorization.customerTel"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("i18n_entrusting_company")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.Authorization.namec,
                                  callback: function($$v) {
                                    _vm.$set(_vm.Authorization, "namec", $$v)
                                  },
                                  expression: "Authorization.namec"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { height: "51px" },
                          attrs: { span: 12 }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("i18n_pay_party"),
                                prop: "payType"
                              }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.entrustInfo.payType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.entrustInfo, "payType", $$v)
                                    },
                                    expression: "entrustInfo.payType"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: "PP" } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("i18n_domestic_payment"))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: "CC" } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("i18n_foreign_payment"))
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("i18n_estimated_receiving_time"),
                                prop: "inWarehouseTime"
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  format: "yyyy-MM-dd",
                                  "value-format": "yyyy-MM-dd",
                                  placeholder: _vm.addPls(
                                    "i18n_warehouse_received_time",
                                    "select"
                                  ),
                                  "picker-options": _vm.pickerSetTime
                                },
                                model: {
                                  value: _vm.entrustInfo.inWarehouseTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.entrustInfo,
                                      "inWarehouseTime",
                                      $$v
                                    )
                                  },
                                  expression: "entrustInfo.inWarehouseTime"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { height: "51px" },
                          attrs: { span: 12 }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("i18n_clearance_metods"),
                                prop: "customsClearanceType"
                              }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.entrustInfo.customsClearanceType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.entrustInfo,
                                        "customsClearanceType",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "entrustInfo.customsClearanceType"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: "Z" } }, [
                                    _vm._v(_vm._s(_vm.$t("i18n_self_clearing")))
                                  ]),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: "S" } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "i18n_Cititran_incharges_of_double_clearing"
                                        )
                                      )
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("i18n_logistics_services")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.productName,
                                  callback: function($$v) {
                                    _vm.productName = $$v
                                  },
                                  expression: "productName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("i18n_remark") } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.entrustInfo.remarks,
                                  callback: function($$v) {
                                    _vm.$set(_vm.entrustInfo, "remarks", $$v)
                                  },
                                  expression: "entrustInfo.remarks"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "Item_list" },
            [
              _c("addressInfo", {
                ref: "address",
                attrs: {
                  sendFeeForAir: _vm.sendFeeForAir,
                  getGoodsDTO: _vm.getGoodsDTO,
                  recGoodsDTO: _vm.recGoodsDTO,
                  delGoodsDTO: _vm.delGoodsDTO,
                  toDoorForm: _vm.toDoorForm,
                  cangkuitem: _vm.cangkuitem
                },
                on: { changeTi: _vm.changeTi, rowClick: _vm.getTimoney }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "Item_list" },
            [
              _c("goodsInfo", {
                attrs: {
                  goodsInfoForm: _vm.goodsInfoForm,
                  goodsTypeOptions: _vm.goodsTypeOptions
                },
                on: {
                  change: _vm.goodsInfoChange,
                  goodTypechange: _vm.goodTypechange,
                  del: _vm.delGoods,
                  edit: _vm.delGoods
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "Item_list" },
            [
              _c("div", { staticClass: "weituo" }, [
                _c("i", {
                  staticClass: "el-icon-s-order",
                  staticStyle: { color: "#63b947", "font-size": "25px" }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "tittype" }, [
                  _vm._v(_vm._s(_vm.$t("i18n_trade_information")))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "addMore" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          icon: "el-icon-upload",
                          size: "medium",
                          type: "text"
                        },
                        on: { click: _vm.upload }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("i18n_upload_clearance_documents"))
                        )
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "tradeForm",
                  attrs: {
                    size: "small",
                    "label-position": "right",
                    "label-width": "106px",
                    model: _vm.tradeInfoForm,
                    rules: _vm.tradeInfoFormRules
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { "label-width": "0" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          on: { change: _vm.tradeInfoChange },
                          model: {
                            value: _vm.declareType,
                            callback: function($$v) {
                              _vm.declareType = $$v
                            },
                            expression: "declareType"
                          }
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { label: "M", name: "type", checked: "" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "i18n_customs_declaration_with_Agent_license"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-checkbox",
                            { attrs: { label: "T", name: "type" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "i18n_customs_declaration_with_tax_refund"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.tradeInfoForm.declareType[0] === "T"
                    ? _c(
                        "div",
                        { staticClass: "Item_list" },
                        [
                          _c("addressInfoDeclarer", {
                            attrs: { declarerDTO: _vm.declarerDTO }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("el-upload", {
                ref: "upload",
                staticClass: "upload-demo",
                attrs: {
                  action: _vm.$store.baseUrl + "/busKY/uploadAirJobsBGInfo",
                  headers: {
                    token: _vm.Authorization.token
                  },
                  limit: 1,
                  "http-request": _vm.fileUpload,
                  "on-success": _vm.handleSuccess,
                  "on-error": _vm.handleError,
                  "on-remove": _vm.handleRemove,
                  "on-exceed": _vm.handleExceed
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "Item_list" },
            [
              _c("div", { staticClass: "weituo" }, [
                _c("i", {
                  staticClass: "el-icon-paperclip",
                  staticStyle: { color: "#63b947", "font-size": "25px" }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "tittype" }, [
                  _vm._v(_vm._s(_vm.$t("i18n_remark")))
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                { attrs: { "label-width": "80px", size: "small" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("i18n_delivery_remark") } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.delGoodsDTO.delGoodsRemarks,
                          callback: function($$v) {
                            _vm.$set(_vm.delGoodsDTO, "delGoodsRemarks", $$v)
                          },
                          expression: "delGoodsDTO.delGoodsRemarks"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("i18n_pickup_remark") } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.getGoodsDTO.getGoodsRemarks,
                          callback: function($$v) {
                            _vm.$set(_vm.getGoodsDTO, "getGoodsRemarks", $$v)
                          },
                          expression: "getGoodsDTO.getGoodsRemarks"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("i18n_Clients_tracking_number") }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.customerNo,
                          callback: function($$v) {
                            _vm.customerNo = $$v
                          },
                          expression: "customerNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("feeDetail", {
          staticClass: "Item_list",
          attrs: {
            auto_fixed: _vm.auto_fixed,
            allMoreFeeInfo: _vm.allMoreFeeInfo,
            transportFeeForAir: _vm.transportFeeForAir,
            pickFeeForAir: _vm.pickFeeForAir,
            currencyCollection: _vm.currencyCollection,
            calculatePrice: _vm.calculatePrice,
            feeList: _vm.feeList,
            pickFeeChecked: _vm.toDoorForm.isGetGoodsToDoor,
            sendFeeChecked: _vm.toDoorForm.isSendGoodsToDoor
          },
          on: { submitOrder: _vm.entrust }
        }),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              title: _vm.$t("i18n_Are_your_confirm_order"),
              center: "",
              visible: _vm.dialogTableVisible,
              width: "520px"
            },
            on: {
              "update:visible": function($event) {
                _vm.dialogTableVisible = $event
              }
            }
          },
          [
            _c("div", { staticClass: "showDalog" }, [
              _c("div", { staticClass: "header_text" }, [
                _c(
                  "div",
                  {
                    staticClass: "count_center",
                    staticStyle: { "margin-right": "50px" }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "cangkutit",
                        staticStyle: { color: "red" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.cangkuitem.namec) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "ckttext",
                        staticStyle: { "margin-top": "10px" }
                      },
                      [_vm._v(_vm._s(_vm.$t("i18n_receving_warehosue")))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "cangkutit",
                    staticStyle: { "margin-right": "50px" }
                  },
                  [
                    _c("img", {
                      staticStyle: { height: "32px" },
                      attrs: {
                        src: require("../../assets/airOrder.png"),
                        alt: ""
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "count_center" }, [
                  _c(
                    "span",
                    { staticClass: "cangkutit", staticStyle: { color: "red" } },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.PScangkuitem.namec) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "ckttext",
                      staticStyle: { "margin-top": "10px" }
                    },
                    [_vm._v(_vm._s(_vm.$t("i18n_destination_city")))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "goodlist",
                  staticStyle: {
                    "margin-top": "40px",
                    width: "100%",
                    float: "left",
                    padding: "0px 40px",
                    "box-sizing": "border-box",
                    "margin-bottom": "30px"
                  }
                },
                [
                  _c("p", { staticStyle: {} }, [
                    _vm._v(_vm._s(_vm.$t("i18n_estimated_cost")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { padding: "5px" } }, [
                    _c(
                      "p",
                      {
                        staticStyle: { "font-weight": "bold", color: "#333333" }
                      },
                      [
                        _vm._v(
                          "\n              CNY " +
                            _vm._s(_vm.calculatePrice) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "Qdbtn LR_center",
                  staticStyle: { "margin-top": "30px" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "btnstyle",
                      staticStyle: {
                        height: "35px",
                        background: "#ffffff",
                        border: "2px solid #dcdcdc",
                        "border-radius": "35px"
                      },
                      on: {
                        click: function($event) {
                          _vm.dialogTableVisible = false
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("i18n_cancel")) +
                          "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btnstyle",
                      staticStyle: {
                        border: "1px solid #5ab53c",
                        "font-size": "30rpx",
                        background: "#ff3939",
                        "border-color": "#ff3939",
                        color: "#ffffff"
                      },
                      on: { click: _vm.submitOrder }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("i18n_confirm_order")) +
                          "\n          "
                      )
                    ]
                  )
                ]
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              visible: _vm.successDialogVisi,
              width: "650px",
              modal: true,
              "close-on-click-modal": false
            },
            on: {
              "update:visible": function($event) {
                _vm.successDialogVisi = $event
              }
            }
          },
          [
            _c("div", { staticClass: "count_center" }, [
              _c("div", { staticClass: "centerCoutn" }, [
                _c(
                  "div",
                  { staticStyle: { width: "100%", "text-align": "center" } },
                  [
                    _c("i", {
                      staticClass:
                        "el-icon-success animate__animated animate__bounceInDown",
                      staticStyle: { "font-size": "55px", color: "#00c300" }
                    }),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-size": "20px",
                          "font-family": "PingFang SC",
                          "font-weight": "500",
                          color: "#333333",
                          "margin-top": "27px"
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("i18n_order_completed")) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          "font-family": "PingFang SC",
                          "font-weight": "500",
                          color: "#999999",
                          "margin-top": "8px"
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t("i18n_waiting_shipment_to_warehoused")
                            ) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "countText" }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("i18n_warehouse_number")) +
                            "：" +
                            _vm._s(
                              _vm.orderInfo.innos ? _vm.orderInfo.innos : ""
                            )
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("i18n_receiver")) +
                            "："
                        ),
                        _c("span", [_vm._v(_vm._s(_vm.sendFeeForAir.name))]),
                        _vm._v(" "),
                        _c("span", { staticStyle: { "margin-left": "10px" } }, [
                          _vm._v(_vm._s(_vm.sendFeeForAir.tel))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("i18n_consignee_address")) +
                            "：" +
                            _vm._s(_vm.sendFeeForAir.country) +
                            _vm._s(_vm.sendFeeForAir.city) +
                            _vm._s(_vm.sendFeeForAir.address) +
                            "\n              "
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btnWrap",
                    staticStyle: { width: "100%", "margin-top": "44px" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "LR_center",
                        staticStyle: { width: "638px" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "btn1",
                            on: {
                              click: function($event) {
                                return _vm.pathBilltab()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("i18n_track_order")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "btn2",
                            on: {
                              click: function($event) {
                                return _vm.nextSetbill()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("i18n_continue_to_order")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "btn2",
                            on: {
                              click: function($event) {
                                return _vm.labelDownload()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("i18n_download_labels")))]
                        )
                      ]
                    )
                  ]
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "商品列表",
              width: "850px",
              visible: _vm.goodsTypeShow,
              "close-on-click-modal": false
            },
            on: {
              "update:visible": function($event) {
                _vm.goodsTypeShow = $event
              }
            }
          },
          [
            _c("div", { staticClass: "typeHeader LR_center" }, [
              _c(
                "div",
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "input-with-select",
                      staticStyle: { width: "314px" },
                      attrs: { placeholder: "请输入中文品名" },
                      model: {
                        value: _vm.page.name,
                        callback: function($$v) {
                          _vm.$set(_vm.page, "name", $$v)
                        },
                        expression: "page.name"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            slot: "append",
                            icon: "el-icon-search",
                            type: "primary"
                          },
                          on: { click: _vm.GetgoodsType },
                          slot: "append"
                        },
                        [_vm._v("搜索")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-select",
                    {
                      ref: "changeFBAgoodtype",
                      staticStyle: { width: "100%" },
                      attrs: { clearable: "", placeholder: "请选择" },
                      on: { change: _vm.GetgoodsType },
                      model: {
                        value: _vm.page.goodstypeid,
                        callback: function($$v) {
                          _vm.$set(_vm.page, "goodstypeid", $$v)
                        },
                        expression: "page.goodstypeid"
                      }
                    },
                    _vm._l(_vm.goodstypelist, function(res) {
                      return _c("el-option", {
                        key: res.id,
                        attrs: { label: res.namec, value: res.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "countTable",
                staticStyle: { "margin-top": "30px" }
              },
              [
                _c(
                  "el-table",
                  {
                    ref: "multipleTable",
                    staticStyle: { width: "100%" },
                    attrs: {
                      border: "",
                      data: _vm.tabbar,
                      "tooltip-effect": "dark"
                    },
                    on: { "selection-change": _vm.handleSelectionChange }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "selection", width: "55" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "中文名称",
                        align: "center",
                        width: "120"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [_vm._v(_vm._s(scope.row.namec))]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "namee",
                        label: "英文品名",
                        align: "center",
                        width: "120"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "materialc",
                        align: "center",
                        label: "中文材质"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "isHasBattery",
                        align: "center",
                        label: "是否带电"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                _vm._s(scope.row.isHasBattery ? "是" : "否")
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "isPowderLiquid",
                        align: "center",
                        label: "是否液体粉末"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                _vm._s(scope.row.isPowderLiquid ? "是" : "否")
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "goodstype",
                        align: "price",
                        label: "商品类型"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "100%",
                      "margin-top": "20px",
                      display: "flex",
                      "flex-direction": "column",
                      "align-items": "center",
                      "justify-content": "center"
                    }
                  },
                  [
                    _c("el-pagination", {
                      attrs: {
                        background: "",
                        layout: "total,prev, pager, next",
                        "page-size": 20,
                        total: _vm.goodslisttotal
                      },
                      on: { "current-change": _vm.handleCurrentChange }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: { width: "100%", "margin-top": "20px" },
                attrs: { slot: "footer" },
                slot: "footer"
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.changeGoodstype }
                  },
                  [_vm._v("确认选择")]
                )
              ],
              1
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a82c23a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a82c23a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/airOrder/newAirOrders.vue
// module id = null
// module chunks = 